var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadcircleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0777 9.84008L17.1895 24.5889",
    stroke: "black",
    strokeWidth: 1.71266,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1464 19.3865C22.3336 20.8013 21.3097 21.9836 20.1157 23.0958C19.5479 23.6247 19.0319 24.2963 18.4289 24.7688C18.2111 24.9394 16.7544 26.2243 16.4393 26.1368C16.3238 26.1048 16.1582 25.7251 16.1088 25.6557C15.8227 25.2536 15.484 24.8917 15.185 24.4992C14.6369 23.7799 14.0112 23.1453 13.4698 22.4207C12.9883 21.7761 12.3993 21.2202 11.9393 20.5564C11.7433 20.2736 11.4783 19.9372 11.1495 19.8304",
    stroke: "black",
    strokeWidth: 1.71266,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6315,
    cy: 17.6321,
    r: 16.5,
    transform: "rotate(179.566 17.6315 17.6321)",
    stroke: "#FB7C51",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadcircleIcon);
export default __webpack_public_path__ + "static/media/downloadcircleIcon.db032b63212562ea745c7db0f342c23f.svg";
export { ForwardRef as ReactComponent };